import Vue from 'vue'
import Router from 'vue-router'
import $ from 'jquery'

import HelloWorld from '@/components/HelloWorld'
import Da from "element-ui/src/locale/lang/da";
import {userOperation, getUserIp} from "../config/axiosUtil";

const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

const router = new Router({
  mode: 'history',
  // base: '/new/',
  routes: [
    {
      path: '*',
      redirect: {path: '/index'}
    },
    {
      path: '/',
      name: '',
      component: ()=>import('../App.vue'),
      children:[
        {
          path: 'index',
          name: 'index',
          components: {
            head: ()=>import('../components/Header.vue'),
            content: ()=>import('../views/index/index.vue'),
            footer: ()=>import('../components/Footer.vue'),
          },
          meta:{
            // 页面标题title
            title: '优卡思-首页'
          }
          // component: ()=>import('../views/index/index.vue')
        },
        {
          path: 'bind',
          name: 'bind',
          components: {
            head: ()=>import('../components/Header.vue'),
            content: ()=>import('../views/index/bind.vue'),
            footer: ()=>import('../components/Footer.vue'),
          },
          meta:{
            // 页面标题title
            title: '优卡思-绑定'
          }
          // component: ()=>import('../views/index/index.vue')
        },
        {
          path: 'more/:types/:which',
          name: 'more',
          components: {
            head: ()=>import('../components/Header.vue'),
            content: ()=>import('../views/index/more.vue'),
            footer: ()=>import('../components/Footer.vue'),
          },
          meta:{
            // 页面标题title
            title: '优卡思'
          }
        },
        {
          path: 'audioList',
          name: 'audioList',
          components: {
            head: ()=>import('../components/Header.vue'),
            content: ()=>import('../views/audio/audioList.vue'),
            footer: ()=>import('../components/Footer.vue'),
          },
          meta:{
            // 页面标题title
            title: '优卡思'
          }
        },
        {
          path: 'creation',
          name: 'creation',
          components: {
            head: ()=>import('../components/HeaderTwo.vue'),
            content: ()=>import('../views/creation/index.vue'),
            // footer: ()=>import('../components/Footer.vue'),
          },
          meta:{
            // 页面标题title
            title: '优卡思-创作中心'
          },
          children:[
            {
              path: 'home',
              name: 'creation-home',
              component: ()=>import('../views/creation/home.vue'),
              meta:{
                // 页面标题title
                title: '优卡思-创作中心'
              },
            },
            {
              path: 'upload',
              name: 'creation-upload',
              component: ()=>import('../views/creation/upload/upload.vue'),
              meta:{
                // 页面标题title
                title: '优卡思-创作中心'
              },
              children:[
                {
                  path: 'video',
                  name: 'creation-upload-video',
                  component: ()=>import('../views/creation/upload/video.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-投稿'
                  },
                },
                {
                  path: 'series',
                  name: 'creation-upload-series',
                  component: ()=>import('../views/creation/upload/series.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-投稿'
                  },
                },
                {
                  path: 'article',
                  name: 'creation-upload-article',
                  component: ()=>import('../views/creation/upload/article.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-投稿'
                  },
                },
                {
                  path: 'articleDraft',
                  name: 'creation-upload-articleDraft',
                  component: ()=>import('../views/creation/upload/articleDraft.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-投稿'
                  },
                },
                {
                  path: 'interactive',
                  name: 'creation-upload-interactive',
                  component: ()=>import('../views/creation/upload/interactive.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-投稿'
                  },
                },
                {
                  path: 'audio',
                  name: 'creation-upload-audio',
                  component: ()=>import('../views/creation/upload/audio.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-投稿'
                  },
                },
              ]
            },
            {
              path: 'manager',
              name: 'creation-manager',
              component: ()=>import('../views/creation/manager/maneger.vue'),
              meta:{
                // 页面标题title
                title: '优卡思-内容管理'
              },
              children:[
                {
                  path: 'article',
                  name: 'creation-manager-article',
                  component: ()=>import('../views/creation/manager/article.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-内容管理'
                  },
                },
                {
                  path: 'createCorpus',
                  name: 'creation-manager-createCorpus',
                  component: ()=>import('../views/creation/manager/createCorpus.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-内容管理'
                  },
                },
                {
                  path: 'corpusList',
                  name: 'creation-manager-corpusList',
                  component: ()=>import('../views/creation/manager/corpusList.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-内容管理'
                  },
                },
                {
                  path: 'video',
                  name: 'creation-manager-video',
                  component: ()=>import('../views/creation/manager/video.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-内容管理'
                  },
                },
                {
                  path: 'interactive',
                  name: 'creation-manager-interactive',
                  component: ()=>import('../views/creation/manager/interactive.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-内容管理'
                  },
                },
                {
                  path: 'series',
                  name: 'creation-manager-series',
                  component: ()=>import('../views/creation/manager/series.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-内容管理'
                  },
                },
                {
                  path: 'audio',
                  name: 'creation-manager-audio',
                  component: ()=>import('../views/creation/manager/audio.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-内容管理'
                  },
                },
                {
                  path: 'video/data',
                  name: 'creation-manager-video-data',
                  component: ()=>import('../views/creation/manager/videoData.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-内容管理'
                  },
                },
                {
                  path: 'video/edit',
                  name: 'creation-manager-video-edit',
                  component: ()=>import('../views/creation/manager/videoEdit.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-内容管理'
                  },
                },
                {
                  path: 'video/settings',
                  name: 'creation-manager-video-settings',
                  component: ()=>import('../views/creation/manager/videoSettings.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-内容管理'
                  },
                },
                {
                  path: 'subtitles',
                  name: 'creation-manager-subtitles',
                  component: ()=>import('../views/creation/manager/subtitles.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-内容管理'
                  },
                  children: [
                    {
                      path: 'videos',
                      name: 'creation-manager-subtitles-videos',
                      component: ()=>import('../views/creation/manager/subtitlesVideos.vue'),
                      meta:{
                        // 页面标题title
                        title: '优卡思-内容管理'
                      },
                    },
                    {
                      path: 'contribute',
                      name: 'creation-manager-subtitles-contribute',
                      component: ()=>import('../views/creation/manager/subtitlesContribute.vue'),
                      meta:{
                        // 页面标题title
                        title: '优卡思-内容管理'
                      },
                    },
                  ]
                },
                {
                  path: 'appeal',
                  name: 'creation-manager-appeal',
                  component: ()=>import('../views/creation/manager/appeal.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-内容管理'
                  },
                },

              ]
            },
            {
              path: 'dataCenter',
              name: 'creation-dataCenter',
              component: ()=>import('../views/creation/dataCenter/dataCenter.vue'),
              meta:{
                // 页面标题title
                title: '优卡思-创作中心-数据中心'
              },
              children:[
                {
                  path: 'video',
                  name: 'creation-dataCenter-video',
                  component: ()=>import('../views/creation/dataCenter/video.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-创作中心-数据中心'
                  },
                },
                {
                  path: 'play',
                  name: 'creation-dataCenter-play',
                  component: ()=>import('../views/creation/dataCenter/play.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-创作中心-数据中心'
                  },
                },
                {
                  path: 'audience',
                  name: 'creation-dataCenter-audience',
                  component: ()=>import('../views/creation/dataCenter/audience.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-创作中心-数据中心'
                  },
                },
                {
                  path: 'article',
                  name: 'creation-dataCenter-article',
                  component: ()=>import('../views/creation/dataCenter/article.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-创作中心-数据中心'
                  },
                },
              ]
            },
            {
              path: 'fans',
              name: 'creation-fans',
              component: ()=>import('../views/creation/fans/fans.vue'),
              meta:{
                // 页面标题title
                title: '优卡思-创作中心-粉丝管理'
              },
              children:[
                {
                  path: 'assist',
                  name: 'creation-fans-assist',
                  component: ()=>import('../views/creation/fans/assist.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-创作中心-粉丝管理'
                  },
                },
                {
                  path: 'medal',
                  name: 'creation-fans-medal',
                  component: ()=>import('../views/creation/fans/medal.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-创作中心-粉丝管理'
                  },
                },
              ]
            },
            {
              path: 'interactive',
              name: 'creation-interactive',
              component: ()=>import('../views/creation/interactive/interactive.vue'),
              meta:{
                // 页面标题title
                title: '优卡思-创作中心-互动管理'
              },
              children:[
                {
                  path: 'barrage',
                  name: 'creation-interactive-barrage',
                  component: ()=>import('../views/creation/interactive/barrage.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-创作中心-弹幕管理'
                  },
                  children:[
                    {
                      path: 'danmu',
                      name: 'creation-interactive-barrage-danmu',
                      component: ()=>import('../views/creation/interactive/barrageDetail.vue'),
                      meta:{
                        // 页面标题title
                        title: '优卡思-创作中心-弹幕管理'
                      },
                    },
                    {
                      path: 'setting',
                      name: 'creation-interactive-barrage-setting',
                      component: ()=>import('../views/creation/interactive/barrageSetting.vue'),
                      meta:{
                        // 页面标题title
                        title: '优卡思-创作中心-弹幕管理'
                      },
                    },
                    {
                      path: 'feedback',
                      name: 'creation-interactive-barrage-feedback',
                      component: ()=>import('../views/creation/interactive/feedback/feedback.vue'),
                      meta:{
                        // 页面标题title
                        title: '优卡思-创作中心-弹幕管理'
                      },
                      children:[
                        {
                          path: 'report',
                          name: 'creation-interactive-barrage-feedback-report',
                          component: ()=>import('../views/creation/interactive/feedback/report.vue'),
                          meta:{
                            // 页面标题title
                            title: '优卡思-创作中心-弹幕管理'
                          },
                        },
                        {
                          path: 'advance',
                          name: 'creation-interactive-barrage-feedback-advance',
                          component: ()=>import('../views/creation/interactive/feedback/advance.vue'),
                          meta:{
                            // 页面标题title
                            title: '优卡思-创作中心-弹幕管理'
                          },
                        },
                        {
                          path: 'protect',
                          name: 'creation-interactive-barrage-feedback-protect',
                          component: ()=>import('../views/creation/interactive/feedback/protect.vue'),
                          meta:{
                            // 页面标题title
                            title: '优卡思-创作中心-弹幕管理'
                          },
                        },
                      ],
                    },
                  ]
                },
                {
                  path: 'comment',
                  name: 'creation-interactive-comment',
                  component: ()=>import('../views/creation/interactive/comment.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-创作中心-评论管理'
                  },
                  children:[
                    {
                      path: 'video',
                      name: 'creation-interactive-comment-video',
                      component: ()=>import('../views/creation/interactive/commentVideo.vue'),
                      meta:{
                        // 页面标题title
                        title: '优卡思-创作中心-评论管理'
                      },
                    },
                    {
                      path: 'article',
                      name: 'creation-interactive-comment-article',
                      component: ()=>import('../views/creation/interactive/commentArticle.vue'),
                      meta:{
                        // 页面标题title
                        title: '优卡思-创作中心-评论管理'
                      },
                    },
                    {
                      path: 'audio',
                      name: 'creation-interactive-comment-audio',
                      component: ()=>import('../views/creation/interactive/commentAudio.vue'),
                      meta:{
                        // 页面标题title
                        title: '优卡思-创作中心-评论管理'
                      },
                    },
                  ]
                },
              ]
            },
            {
              path: 'earnings',
              name: 'creation-earnings',
              component: ()=>import('../views/creation/earnings/earnings.vue'),
              meta:{
                // 页面标题title
                title: '优卡思-创作中心-收益管理'
              },
              children:[
                {
                  path: 'excitation',
                  name: 'creation-earnings-excitation',
                  component: ()=>import('../views/creation/earnings/excitation.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-创作中心-创作激励'
                  },
                },
                {
                  path: 'board',
                  name: 'creation-earnings-board',
                  component: ()=>import('../views/creation/earnings/board.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-创作中心-创作激励'
                  },
                },
                {
                  path: 'charge',
                  name: 'creation-earnings-charge',
                  component: ()=>import('../views/creation/earnings/charge.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-创作中心-充电计划'
                  },
                },
                {
                  path: 'chargeOrdering',
                  name: 'creation-earnings-chargeOrdering',
                  component: ()=>import('../views/creation/earnings/chargeOrdering.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-创作中心-充电计划'
                  },
                },
                {
                  path: 'chargeHistory',
                  name: 'creation-earnings-chargeHistory',
                  component: ()=>import('../views/creation/earnings/chargeHistory.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-创作中心-充电计划'
                  },
                },
                {
                  path: 'reward',
                  name: 'creation-earnings-reward',
                  component: ()=>import('../views/creation/earnings/reward.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-创作中心-悬赏计划'
                  },
                },
                {
                  path: 'petard',
                  name: 'creation-earnings-petard',
                  component: ()=>import('../views/creation/earnings/petard.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-创作中心-火花平台'
                  },
                },
              ]
            },
            {
              path: 'electromagnetic',
              name: 'creation-electromagnetic',
              component: ()=>import('../views/creation/electromagnetic/electromagnetic.vue'),
              meta:{
                // 页面标题title
                title: '优卡思-创作中心'
              },
              children:[
                {
                  path: 'index',
                  name: 'creation-electromagnetic-index',
                  component: ()=>import('../views/creation/electromagnetic/index.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-创作中心'
                  },
                },
                {
                  path: 'example',
                  name: 'creation-electromagnetic-example',
                  component: ()=>import('../views/creation/electromagnetic/example.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-创作中心'
                  },
                },
                {
                  path: 'credit',
                  name: 'creation-electromagnetic-credit',
                  component: ()=>import('../views/creation/electromagnetic/credit.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-创作中心'
                  },
                },
              ]
            },
            {
              path: 'growing',
              name: 'creation-growing',
              component: ()=>import('../views/creation/growing/growing.vue'),
              meta:{
                // 页面标题title
                title: '优卡思-创作中心-创作成长'
              },
              children:[
                {
                  path: 'achievement',
                  name: 'creation-growing-achievement',
                  component: ()=>import('../views/creation/growing/achievement.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-创作中心-任务成就'
                  },
                },
              ]
            },

            {
              path: 'treaty',
              name: 'create-protocal-treaty',
              component: ()=>import('../views/creation/protocal/treaty.vue'),
              meta:{
                // 页面标题title
                title: '优卡思'
              },
            },
            {
              path: 'licence',
              name: 'create-protocal-licence',
              component: ()=>import('../views/creation/protocal/licence.vue'),
              meta:{
                // 页面标题title
                title: '优卡思'
              },
            },
            {
              path: 'setting',
              name: 'creation-setting',
              component: ()=>import('../views/creation/setting.vue'),
              meta:{
                // 页面标题title
                title: '优卡思-创作中心'
              },
            },
          ]
        },
        {
          path: 'plotTree',
          name: 'plotTree',
          component: ()=>import('../views/creation/videoPlotTree.vue'),
          meta:{
            // 页面标题title
            title: '优卡思-创作中心'
          },
        },
        {
          path: 'read',
          name: 'read',
          component: ()=>import('../views/read/read.vue'),
          meta:{
            // 页面标题title
            title: '优卡思-专栏'
          },
          children: [
            {
              path: 'home',
              name: 'read-home',
              components: {
                head: ()=>import('../components/Header.vue'),
                content: ()=>import('../views/read/home.vue'),
              },
              meta:{
                // 页面标题title
                title: '优卡思-专栏'
              },
            },
            {
              path: 'pcpreview',
              name: 'read-pc-preview',
              component: ()=>import('../views/read/pcpreview.vue'),
              meta:{
                // 页面标题title
                title: '优卡思-专栏'
              },
            },
            {
              path: 'preview',
              name: 'read-preview',
              component: ()=>import('../views/read/preview.vue'),
              meta:{
                // 页面标题title
                title: '优卡思-专栏'
              },
            },
          ]
        },

        {
          path: 'message',
          name: 'message',
          components: {
            head: ()=>import('../components/Header.vue'),
            content: ()=>import('../views/message/index.vue'),
          },
          meta:{
            // 页面标题title
            title: '优卡思-消息中心'
          },
          children:[
            {
              path: 'reply',
              name: 'message-reply',
              component: ()=>import('../views/message/reply.vue'),
              meta:{
                // 页面标题title
                title: '优卡思-消息中心'
              },
            },
            {
              path: 'at',
              name: 'message-at',
              component: ()=>import('../views/message/at.vue'),
              meta:{
                // 页面标题title
                title: '优卡思-消息中心'
              },
            },
            {
              path: 'love',
              name: 'message-love',
              component: ()=>import('../views/message/love.vue'),
              meta:{
                // 页面标题title
                title: '优卡思-消息中心'
              },
            },
            {
              path: 'config',
              name: 'message-config',
              component: ()=>import('../views/message/config.vue'),
              meta:{
                // 页面标题title
                title: '优卡思-消息中心'
              },
            },
            {
              path: 'system',
              name: 'message-system',
              component: ()=>import('../views/message/system.vue'),
              meta:{
                // 页面标题title
                title: '优卡思-消息中心'
              },
            },
            {
              path: 'whisper',
              name: 'message-whisper',
              component: ()=>import('../views/message/whisper.vue'),
              meta:{
                // 页面标题title
                title: '优卡思-消息中心'
              },
            },
            ]
        },
        {
          path: 'dynamic',
          name: 'dynamic',
          components: {
            head: ()=>import('../components/Header.vue'),
            content: ()=>import('../views/dynamic/dynamic.vue'),
          },
          meta:{
            title: '优卡思-动态'
          },
          children: [
            {
              path: 'list',
              name: 'dynamic-list',
              component: ()=>import('../views/dynamic/list.vue'),
              meta:{
                // 页面标题title
                title: '优卡思-动态首页'
              },
            },
          ],
        },
        {
          path: 'dynamic/opus/:ID/:types',
          name: 'dynamic-opus',
          components: {
            head: ()=>import('../components/Header.vue'),
            content: ()=>import('../views/dynamic/opus.vue'),
          },
          meta:{
            // 页面标题title
            title: '优卡思-动态详情页'
          },
        },
        {
          path: 'blackboard',
          name: 'blackboard',
          components: {
            head: ()=>import('../components/Header.vue'),
            content: ()=>import('../views/blackboard/blackboard.vue'),
            footer: ()=>import('../components/Footer.vue'),
          },
          // component: ()=>import('../views/blackboard/blackboard.vue'),
          meta:{
            // 页面标题title
            title: '优卡思-帮助中心'
          },
          children: [
            {
              path: 'blackroom',
              name: 'blackboard-blackroom',
              component: ()=>import('../views/blackboard/blackroom.vue'),
              meta:{
                // 页面标题title
                title: '优卡思-帮助中心'
              },
            },
            {
              path: 'help',
              name: 'blackboard-help',
              component: ()=>import('../views/blackboard/help.vue'),
              meta: {
                title: '优卡思-帮助'
              }
            },
            {
              path: 'aboutUS',
              name: 'blackboard-aboutUS',
              component: ()=>import('../views/blackboard/aboutUS.vue'),
              meta:{
                // 页面标题title
                title: '优卡思-关于我们'
              },
            },
            {
              path: 'contact',
              name: 'blackboard-contact',
              component: ()=>import('../views/blackboard/contact.vue'),
              meta:{
                // 页面标题title
                title: '优卡思-联系我们'
              },
            },
            {
              path: 'licence',
              name: 'blackboard-licence',
              component: ()=>import('../views/blackboard/licence.vue'),
              meta:{
                // 页面标题title
                title: '优卡思-用户协议'
              },
            },
            {
              path: 'privacy',
              name: 'blackboard-privacy',
              component: ()=>import('../views/blackboard/privacy.vue'),
              meta: {
                title: '优卡思-隐私政策'
              }
            },
            {
              path: 'joinUS',
              name: 'blackboard-joinUS',
              component: ()=>import('../views/blackboard/joinUS.vue'),
              meta: {
                title: '优卡思-加入我们'
              }
            },
            {
              path: 'topic-list',
              name: 'blackboard-topic-list',
              component: ()=>import('../views/blackboard/topicList.vue'),
              meta:{
                // 页面标题title
                title: '优卡思-帮助中心'
              },
            },
            {
              path: 'credit',
              name: 'blackboard-credit',
              component: ()=>import('../views/blackboard/credit.vue'),
              meta:{
                // 页面标题title
                title: '优卡思-帮助中心'
              },
            },
            {
              path: 'charge-privacy',
              name: 'blackboard-charge-privacy',
              component: ()=>import('../views/blackboard/chargePrivacy.vue'),
              meta:{
                // 页面标题title
                title: '优卡思-帮助中心'
              },
            },
            {
              path: 'activity',
              name: 'blackboard-activity',
              component: ()=>import('../views/blackboard/activity.vue'),
              meta:{
                // 页面标题title
                title: '优卡思-帮助中心'
              },
            },
            {
              path: 'agreementPay',
              name: 'blackboard-agreementPay',
              component: ()=>import('../views/blackboard/agreementPay.vue'),
              meta: {
                title: '优卡思-B币用户协议'
              }
            },
            {
              path: 'bigProtocol',
              name: 'blackboard-bigProtocol',
              component: ()=>import('../views/blackboard/bigProtocol.vue'),
              meta: {
                title: '优卡思-大会员协议'
              }
            },
          ]
        },
        {
          path: 'account',
          name: 'account',
          components: {
            head: ()=>import('../components/Header.vue'),
            content: ()=>import('../views/account/account.vue'),
            // footer: ()=>import('../components/Footer.vue'),
          },
          meta:{
            // 页面标题title
            title: '优卡思-个人中心'
          },
          // component: ()=>import('../views/account/account1.vue'),
          children: [
            {
              path: 'home',
              name: 'account-home',
              component: ()=>import('../views/account/home.vue'),
              meta:{
                // 页面标题title
                title: '优卡思-个人中心'
              },
            },
            {
              path: 'big',
              name: 'account-big',
              component: ()=>import('../views/account/big.vue'),
              meta:{
                // 页面标题title
                title: '优卡思-个人中心'
              },
            },
            {
              path: 'setting',
              name: 'account-setting',
              component: ()=>import('../views/account/setting.vue'),
              meta:{
                // 页面标题title
                title: '优卡思-个人中心'
              },
            },
            {
              path: 'face',
              name: 'account-face',
              component: ()=>import('../views/account/face/face.vue'),
              meta:{
                // 页面标题title
                title: '优卡思-个人中心'
              },
              children:[
                {
                  path: 'vip',
                  name: 'account-face-vip',
                  component: ()=>import('../views/account/face/vip.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-个人中心'
                  },
                },
                {
                  path: 'mine',
                  name: 'account-face-mine',
                  component: ()=>import('../views/account/face/mine.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-个人中心'
                  },
                },
                {
                  path: 'pendantRecord',
                  name: 'account-face-pendantRecord',
                  component: ()=>import('../views/account/face/pendantRecord.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-个人中心'
                  },
                },
                {
                  path: 'upload',
                  name: 'account-face-upload',
                  component: ()=>import('../views/account/face/upload.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-个人中心'
                  },
                },
              ]
            },
            {
              path: 'pay',
              name: 'account-pay',
              component: ()=>import('../views/account/pay/pay.vue'),
              meta:{
                // 页面标题title
                title: '优卡思'
              },
              children:[
                {
                  path: 'index',
                  name: 'account-pay-index',
                  component: ()=>import('../views/account/pay/index.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思'
                  },
                },
                {
                  path: 'recharge',
                  name: 'account-pay-recharge',
                  component: ()=>import('../views/account/pay/recharge.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思'
                  },
                },
                {
                  path: 'record',
                  name: 'account-pay-record',
                  component: ()=>import('../views/account/pay/record.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思'
                  },
                },
              ]
            },
            {
              path: 'security',
              name: 'account-security',
              component: ()=>import('../views/account/security/home.vue'),
              meta:{
                // 页面标题title
                title: '优卡思-个人中心'
              },
              children:[
                {
                  path: 'home',
                  name: 'account-security-home',
                  component: ()=>import('../views/account/security/security.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-个人中心'
                  },
                },
                {
                  path: 'bindmail',
                  name: 'account-security-bindmail',
                  component: ()=>import('../views/account/security/bindmail.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-个人中心'
                  },
                },
                {
                  path: 'bindphone',
                  name: 'account-security-bindphone',
                  component: ()=>import('../views/account/security/bindphone.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-个人中心'
                  },
                },
                {
                  path: 'setquestion',
                  name: 'account-security-setquestion',
                  component: ()=>import('../views/account/security/protection.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-个人中心'
                  },
                },
                {
                  path: 'setpassword',
                  name: 'account-security-setpassword',
                  component: ()=>import('../views/account/security/setpassword.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-个人中心'
                  },
                },
              ]
            },
            {
              path: 'blacklist',
              name: 'account-blacklist',
              component: ()=>import('../views/account/blacklist.vue'),
              meta:{
                // 页面标题title
                title: '优卡思-个人中心'
              },
            },
            {
              path: 'coin',
              name: 'account-coin',
              component: ()=>import('../views/account/coin.vue'),
              meta:{
                // 页面标题title
                title: '优卡思-个人中心'
              },
            },
            {
              path: 'record',
              name: 'account-record',
              component: ()=>import('../views/account/record.vue'),
              meta:{
                // 页面标题title
                title: '优卡思-个人中心'
              },
            },
            {
              path: 'fansMedal',
              name: 'account-fansMedal',
              component: ()=>import('../views/account/fansMedal.vue'),
              meta:{
                // 页面标题title
                title: '优卡思-个人中心'
              },
            },
            {
              path: 'realname',
              name: 'account-realname',
              component: ()=>import('../views/account/realname.vue'),
              meta:{
                // 页面标题title
                title: '优卡思-个人中心'
              },
              children: [
                {
                  path: 'identify',
                  name: 'account-realname-identify',
                  component: ()=>import('../views/account/identify.vue'),
                  meta:{
                    // 页面标题title
                    title: '优卡思-个人中心'
                  },
                },
              ]
            },
            {
              path: 'history',
              name: 'account-history',
              component: ()=>import('../views/account/history.vue'),
              meta:{
                // 页面标题title
                title: '优卡思-个人中心'
              },
            },
          ]
        },
        {
          path: 'academy',
          name: 'academy',
          component: ()=>import('../views/academy/academy.vue'),
          meta:{
            // 页面标题title
            title: '优卡思-创作学院'
          },
          children: [
            {
              path: 'index',
              name: 'academy-index',
              component: ()=>import('../views/academy/index.vue'),
              meta: {
                title: '优卡思-创作学院首页'
              }
            },
          ]
        },
        {
          path: 'search',
          name: 'search',
          components: {
            head: ()=>import('../components/Header.vue'),
            content: ()=>import('../views/search/search.vue'),
            footer: ()=>import('../components/Footer.vue'),
          },
          meta:{
            // 页面标题title
            title: '优卡思-搜索'
          },
          children: [
            {
              path: 'all',
              name: 'search-all',
              component: ()=>import('../views/search/all.vue'),
              meta: {
                title: '优卡思-搜索-综合'
              }
            },
            {
              path: 'video',
              name: 'search-video',
              component: ()=>import('../views/search/video.vue'),
              meta: {
                title: '优卡思-搜索-视频'
              }
            },
            {
              path: 'series',
              name: 'search-series',
              component: ()=>import('../views/search/series.vue'),
              meta: {
                title: '优卡思-搜索-番剧'
              }
            },
            {
              path: 'interactive',
              name: 'search-interactive',
              component: ()=>import('../views/search/interactive.vue'),
              meta: {
                title: '优卡思-搜索-多视频'
              }
            },
            {
              path: 'article',
              name: 'search-article',
              component: ()=>import('../views/search/article.vue'),
              meta: {
                title: '优卡思-搜索-文章'
              }
            },
            {
              path: 'user',
              name: 'search-user',
              component: ()=>import('../views/search/user.vue'),
              meta: {
                title: '优卡思-搜索-用户'
              }
            },
          ]
        },

        {
          path: 'user/:ID',
          name: 'user',
          components: {
            head: ()=>import('../components/Header.vue'),
            content: ()=>import('../views/user/home.vue'),
          },
          meta:{
            // 页面标题title
            title: '优卡思-个人空间'
          },
          children: [
            {
              path: 'home',
              name: 'user-home',
              component: ()=>import('../views/user/index.vue'),
              meta: {
                title: '优卡思-用户-首页'
              }
            },
            {
              path: 'dynamic',
              name: 'user-dynamic',
              component: ()=>import('../views/user/dynamic.vue'),
              meta: {
                title: '优卡思-用户-动态'
              }
            },
            {
              path: '',
              name: 'user-upload',
              component: ()=>import('../views/user/upload.vue'),
              meta: {
                title: '优卡思-用户-投稿'
              },
              children: [
                {
                  path: 'video',
                  name: 'user-video',
                  component: ()=>import('../views/user/video.vue'),
                  meta: {
                    title: '优卡思-用户-视频'
                  }
                },
                {
                  path: 'article',
                  name: 'user-article',
                  component: ()=>import('../views/user/article.vue'),
                  meta: {
                    title: '优卡思-用户-文章'
                  }
                },
                {
                  path: 'audio',
                  name: 'user-audio',
                  component: ()=>import('../views/user/audio.vue'),
                  meta: {
                    title: '优卡思-用户-音频'
                  }
                },
                {
                  path: 'series',
                  name: 'user-series',
                  component: ()=>import('../views/user/series.vue'),
                  meta: {
                    title: '优卡思-用户-番剧'
                  }
                },
                {
                  path: 'interactive',
                  name: 'user-interactive',
                  component: ()=>import('../views/user/interactive.vue'),
                  meta: {
                    title: '优卡思-用户-多视频'
                  }
                },
              ]
            },
            {
              path: 'channel',
              name: 'user-channel',
              component: ()=>import('../views/user/channel.vue'),
              meta: {
                title: '优卡思-用户-合集'
              }
            },
            {
              path: 'channeldetail',
              name: 'user-channeldetail',
              component: ()=>import('../views/user/channeldetail.vue'),
              meta: {
                title: '优卡思-用户-合集详情'
              }
            },
            {
              path: 'favlist',
              name: 'user-favlist',
              component: ()=>import('../views/user/favlist.vue'),
              meta: {
                title: '优卡思-用户-收藏'
              }
            },
            {
              path: 'bangumi',
              name: 'user-bangumi',
              component: ()=>import('../views/user/bangumi.vue'),
              meta: {
                title: '优卡思-用户-订阅'
              }
            },
            {
              path: 'setting',
              name: 'user-setting',
              component: ()=>import('../views/user/setting.vue'),
              meta: {
                title: '优卡思-用户-设置'
              }
            },
            {
              path: 'search',
              name: 'user-search',
              component: ()=>import('../views/user/upload.vue'),
              meta: {
                title: '优卡思-用户-搜索'
              },
              children: [
                {
                  path: 'video',
                  name: 'user-search-video',
                  component: ()=>import('../views/user/video.vue'),
                  meta: {
                    title: '优卡思-用户-视频'
                  }
                },
                {
                  path: 'article',
                  name: 'user-search-article',
                  component: ()=>import('../views/user/article.vue'),
                  meta: {
                    title: '优卡思-用户-文章'
                  }
                },
                {
                  path: 'audio',
                  name: 'user-search-audio',
                  component: ()=>import('../views/user/audio.vue'),
                  meta: {
                    title: '优卡思-用户-音频'
                  }
                },
                {
                  path: 'series',
                  name: 'user-search-series',
                  component: ()=>import('../views/user/series.vue'),
                  meta: {
                    title: '优卡思-用户-番剧'
                  }
                },
                {
                  path: 'interactive',
                  name: 'user-search-interactive',
                  component: ()=>import('../views/user/interactive.vue'),
                  meta: {
                    title: '优卡思-用户-多视频'
                  }
                },
              ]
            },
            {
              path: 'fans',
              name: 'user-fans-follow',
              component: ()=>import('../views/user/fansAndFollow.vue'),
              meta: {
                title: '优卡思-用户-粉丝-关注'
              },
              children: [
                {
                  path: 'fans',
                  name: 'user-fans',
                  component: ()=>import('../views/user/fans.vue'),
                  meta: {
                    title: '优卡思-用户-粉丝'
                  }
                },
                {
                  path: 'follow',
                  name: 'user-follow',
                  component: ()=>import('../views/user/follow.vue'),
                  meta: {
                    title: '优卡思-用户-关注'
                  }
                },
              ]
            },
          ]
        },
        {
          path: 'video/:BVID',
          name: 'video',
          components: {
            head: ()=>import('../components/Header.vue'),
            content: ()=>import('../views/video/videoDetail.vue'),
          },
          meta:{
            // 页面标题title
          },
        },
        {
          path: 'series/:BVID',
          name: 'series',
          components: {
            head: ()=>import('../components/Header.vue'),
            content: ()=>import('../views/video/seriesDetail.vue'),
          },
          meta:{
            // 页面标题title
          },
        },
        {
          path: 'interactive/:BVID',
          name: 'interactive',
          components: {
            head: ()=>import('../components/Header.vue'),
            content: ()=>import('../views/video/interactiveDetail.vue'),
          },
          meta:{
            // 页面标题title
          },
        },
        {
          path: 'purchasedVideo',
          name: 'purchasedVideo',
          components: {
            head: ()=>import('../components/Header.vue'),
            content: ()=>import('../views/video/purchasedVideo.vue'),
          },
          meta:{
            // 页面标题title
            title: '优卡思-已购视频'
          },
        },
        {
          path: 'article/:CVID',
          name: 'article',
          components: {
            head: ()=>import('../components/Header.vue'),
            content: ()=>import('../views/article/articleDetail.vue'),
          },
          meta:{
            // 页面标题title
          },
        },
        {
          path: 'audio/:AUID',
          name: 'audio',
          components: {
            head: ()=>import('../components/Header.vue'),
            content: ()=>import('../views/audio/audioDetail.vue'),
            audioPlayer: ()=>import('../components/audioPlayerPage.vue'),
          },
          meta:{
            // 页面标题title
          },
        },
        {
          path: 'audioCollect/:AMID',
          name: 'audioCollect',
          components: {
            head: ()=>import('../components/Header.vue'),
            content: ()=>import('../views/audio/audioCollection.vue'),
            audioPlayer: ()=>import('../components/audioPlayerPage.vue'),
          },
          meta:{
            // 页面标题title
          },
        },
        {
          path: 'buyvip',
          name: 'buyvip',
          components: {
            head: ()=>import('../components/Header.vue'),
            content: ()=>import('../views/buyvip.vue'),
          },
          meta:{
            // 页面标题title
            title: '优卡思-支付'
          },
        },
        {
          path: 'watchlater',
          name: 'watchlater',
          components: {
            head: ()=>import('../components/Header.vue'),
            content: ()=>import('../views/watchlater.vue'),
          },
          meta: {
            title: '优卡思-稍后再看'
          }
        },
        {
          path: 'topic',
          name: 'topic',
          component: ()=>import('../views/topic/topic.vue'),
          meta:{
            // 页面标题title
            title: '优卡思-话题论坛'
          },
        },
        {
          path: 'onlineService',
          name: 'onlineService',
          component: ()=>import('../views/onlineService/onlineService.vue'),
          meta:{
            // 页面标题title
            title: '优卡思-在线客服'
          },
        },

        {
          path: 'previewTest',
          name: 'previewTest',
          component: ()=>import('../views/test/previewTest.vue'),
          meta:{
            // 页面标题title
            title: '优卡思'
          },
        },
        {
          path: 'barrageTest',
          name: 'barrageTest',
          component: ()=>import('../views/test/barrageTest.vue'),
          meta:{
            // 页面标题title
            title: '优卡思'
          },
        },
        {
          path: 'canvasTest',
          name: 'canvasTest',
          component: ()=>import('../views/test/canvasTest.vue'),
          meta:{
            // 页面标题title
            title: '优卡思'
          },
        },
        {
          path: 'scrollTest',
          name: 'scrollTest',
          component: ()=>import('../views/test/scrollTest.vue'),
          meta:{
            // 页面标题title
            title: '优卡思'
          },
        },
        {
          path: 'dragTest',
          name: 'dragTest',
          component: ()=>import('../views/test/dragTest.vue'),
          meta:{
            // 页面标题title
            title: '优卡思'
          },
        },
        {
          path: 'wangEditor',
          name: 'wangEditor',
          component: ()=>import('../components/wangEditor.vue'),
          meta:{
            // 页面标题title
            title: '优卡思'
          },
        },
        {
          path: 'dplayer',
          name: 'dplayer',
          component: ()=>import('../components/dplayer.vue'),
          meta:{
            // 页面标题title
            title: '优卡思'
          },
        },
        {
          path: 'muiPlayer',
          name: 'muiPlayer',
          component: ()=>import('../components/muiPlayer.vue'),
          meta:{
            // 页面标题title
            title: '优卡思'
          },
        },
        {
          path: 'playerDetail',
          name: 'playerDetail',
          component: ()=>import('../components/playerDetail.vue'),
          meta:{
            // 页面标题title
            title: '优卡思'
          },
        },
      ],
    },
    {
      path: '/app',
      name: 'app',
      component: ()=>import('../app/module.vue'),
      meta: {
        title: '易拼拼'
      },
      children: [
        {
          path: 'index',
          name: 'app-index',
          component: ()=>import('../app/index.vue'),
          meta: {
            title: '易拼拼-首页'
          }
        },
        {
          path: 'about',
          name: 'app-about',
          component: ()=>import('../app/about.vue'),
          meta: {
            title: '易拼拼-关于我们'
          }
        },
        {
          path: 'contact',
          name: 'app-contact',
          component: ()=>import('../app/contact.vue'),
          meta: {
            title: '易拼拼-联系我们'
          }
        },
        {
          path: 'features',
          name: 'app-features',
          component: ()=>import('../app/features.vue'),
          meta: {
            title: '易拼拼-功能介绍'
          }
        },
        {
          path: 'more',
          name: 'app-more',
          component: ()=>import('../app/more.vue'),
          meta: {
            title: '易拼拼-了解更多'
          }
        },
        {
          path: 'shops',
          name: 'app-shops',
          component: ()=>import('../app/shops.vue'),
          meta: {
            title: '易拼拼-宝贝详情'
          }
        },
        {
          path: 'download',
          name: 'app-download',
          component: ()=>import('../app/download.vue'),
          meta: {
            title: '易拼拼'
          }
        },
        {
          path: 'user',
          name: 'app-user',
          component: ()=>import('../app/user.vue'),
          meta: {
            title: '易拼拼-个人主页'
          }
        },
      ]
    },

  ]
})



// 进行路由判断
router.beforeEach((to, from, next) => {
  if(to.meta.title){
    document.title = to.meta.title
  }
  let times = Date.now()
  if(to.name === 'video' || to.name === 'series' || to.name === 'interactive'){
    let params = new FormData()
    params.append('id', to.params.BVID)
    params.append('types', '观看视频')
    params.append('times', times)
    localStorage.setItem('videoLookTime', times)
    userOperation(params).then(data=>{}).catch(err=>{})
  }else if(to.name === 'audio' || to.name === 'audioCollect'){
    let params = new FormData()
    if(to.name==='audio'){
      params.append('id', to.params.AUID)
    }else {
      params.append('id', to.params.AMID)
    }
    params.append('types', '播放音频')
    params.append('times', times)
    localStorage.setItem('audioLookTime', times)
    userOperation(params).then(data=>{}).catch(err=>{})
  }else if(to.name === 'article'){
    let params = new FormData()
    params.append('id', to.params.CVID)
    params.append('types', '阅读文章')
    params.append('times', times)
    localStorage.setItem('articleLookTime', times)
    userOperation(params).then(data=>{}).catch(err=>{})
  }
  if(from.name === 'video' || from.name === 'series' || from.name === 'interactive'){
    let params = new FormData()
    params.append('id', from.params.BVID)
    params.append('types', '观看视频')
    params.append('lastTime', Date.now())
    params.append('times', localStorage.getItem('videoLookTime') || '')
    userOperation(params).then(data=>{}).catch(err=>{})
  }else if(from.name === 'audio' || from.name === 'audioCollect'){
    let params = new FormData()
    if(from.name==='audio'){
      params.append('id', from.params.AUID)
    }else {
      params.append('id', from.params.AMID)
    }
    params.append('types', '播放音频')
    params.append('lastTime', Date.now())
    params.append('times', localStorage.getItem('audioLookTime') || '')
    userOperation(params).then(data=>{}).catch(err=>{})
  }else if(from.name === 'article'){
    let params = new FormData()
    params.append('id', from.params.CVID)
    params.append('types', '阅读文章')
    params.append('lastTime', Date.now())
    params.append('times', localStorage.getItem('articleLookTime') || '')
    userOperation(params).then(data=>{}).catch(err=>{})
  }
  if (localStorage.getItem('iiucasToken') !== null) {

    getUserIp().then(data=>{

    }).catch(err=>{
      console.log(err)
    })
  }
  if(from.name === 'creation-upload-video' || from.name === 'creation-upload-interactive' || from.name === 'creation-upload-series'){
    if($('.upload-container').find('.upload-step2-container')[0].style.display !== 'none'){
      Vue.prototype.$confirm('系统可能不会保存填写的稿件信息噢...', '确定要离开吗?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(() => {
        next()
      }).catch(()=>{
        next(false)
      })
    }else {
      next()
    }

  }else {
    if (to.path === '/') {
      next({
        // path: '/new/index'
        path: '/index'
      })
    } else {
      next()
    }
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js